import APITemplate from '@api/APITemplate'
import { formatQueryParams } from '@utils/Format'
import con from '@services/connection'
import { minhaCarteira, simulador, portfolioModelo } from '@constants/URL'
import { buildWalletQueryParams } from '@modules/consolidator/utils/FormatWalletRequest/FormatWalletRequest'
import moment from 'moment'

// Agrupamento padrão da composição (espelha o load default de minha-carteira).
const FRACOES_GROUP_BY = 'subclasse'

const buildStatsUrl = ({
  isClient,
  clienteId,
  group,
  withGraph,
  filtroCorretora,
  modoFiltroCorretora,
  dataFim,
  dataInicio,
}) => {
  const params = { group_by: group, with_graph: withGraph }
  const filtro = filtroCorretora === 'Consolidado' ? 'Todos' : filtroCorretora
  params[modoFiltroCorretora || 'corretora'] = filtro

  let baseUrl = isClient
    ? minhaCarteira.cliente.estatisticas_benchmark
    : minhaCarteira.estatisticas_benchmark + (clienteId || '')

  if (dataFim) {
    const parsed =
      dataFim.indexOf('/') > -1
        ? moment(dataFim, 'DD/MM/YYYY')
        : moment(dataFim, 'YYYY-MM-DD')
    if (parsed.isValid()) {
      params.end_date = parsed.format('DD-MM-YYYY')
    }
  }

  if (dataInicio) {
    // Calculate begin_date as 6 months before end_date
      const beginDate = dataInicio
        ? dataInicio.indexOf('/') > -1
          ? moment(dataInicio, 'DD/MM/YYYY')
          : moment(dataInicio, 'DD-MM-YYYY')
        : moment().subtract(6, 'months')
      if (beginDate.isValid()) {
        params.begin_date = beginDate.format('DD-MM-YYYY')
      }
  }

  return baseUrl + formatQueryParams(params)
}

class APIConsolidatorCarteiraAtivos extends APITemplate {
  constructor() {
    super()
    this.reqCarregar = null
  }

  async getStatisticsAssets({
    isClient,
    clienteId,
    group,
    withGraph,
    filtroCorretora,
    modoFiltroCorretora,
    dataFim,
    dataInicio,
    returnStatistics = true,
    begin_date,
  } = {}) {
    if (!isClient && !clienteId) {
      return {
        status: 404,
        message: 'Cliente não informado',
        value: clienteId,
      }
    }
    const url = buildStatsUrl({
      isClient,
      clienteId,
      group,
      withGraph,
      filtroCorretora,
      modoFiltroCorretora,
      dataFim,
      dataInicio,
    })
    const r = await con.get(url)
    if (returnStatistics) {
      const value =
        r && r.status === 200 && r.value && r.value.statistics
          ? r.value.statistics
          : {}

      return { status: r ? r.status : 500, value }
    } else {
      return r || {}
    }
  }

  /**
   * Carrega as carteiras recomendadas de um cliente com base no perfil suitability.
   * Busca o perfil do cliente e filtra as composições do portfolio modelo.
   * @param {Object} params
   * @param {String|Number} params.idCliente - ID do cliente
   * @returns {Array} carteiras recomendadas ou []
   */
  async carregarCarteirasRecomendadasCliente({ idCliente }) {
    try {
      const s = await con.get(simulador.dados_cliente + idCliente)
      if (!s || s.status !== 200 || !s.value || !s.value.perfil) {
        return []
      }
      const perfil = s.value.perfil
      const r = await con.get(portfolioModelo.read)
      if (!r || !r.value) {
        return []
      }
      const composicao = r.value.find((p) => p.nome === perfil)
      if (
        composicao &&
        composicao._carteiras_recomendadas &&
        composicao._carteiras_recomendadas.length
      ) {
        return composicao._carteiras_recomendadas
      }
      return []
    } catch (e) {
      return []
    }
  }

  /**
   * Carrega a composição/frações de um cliente (mesma fonte que
   * minha-carteira usa para `result_fracoes`). Retorna o objeto bruto, que
   * inclui `status_anbima`, `anbima_fracoes` e `client_allocation_status`.
   * @param {Object} params
   * @param {String|Number} params.idCliente - ID do cliente
   * @returns {Object} result_fracoes (r.value) ou null em erro/sem cliente
   */
  async carregarFracoesCliente({ idCliente } = {}) {
    if (!idCliente) return null
    const params = buildWalletQueryParams({ groupBy: FRACOES_GROUP_BY })
    const query = formatQueryParams(params)
    const r = await con.post(minhaCarteira.composicao + query, {
      id_cliente: idCliente,
    })
    if (r && r.status === 200 && r.value) {
      return r.value
    }
    return null
  }
}

const apiConsolidatorCarteiraAtivos = new APIConsolidatorCarteiraAtivos()
export { apiConsolidatorCarteiraAtivos, buildStatsUrl }
